/** Verdele lotului — iarba, pomii, spațiul verde al planșei — stins față de
 *  culoarea lui plină. Saturat, verdele trăgea privirea de pe clădiri, pe
 *  machetă (lângă orașul alb-gri din jur) și pe planul de situație deopotrivă.
 *  Un singur factor pentru toate, ca 2D și 3D să rămână din aceeași paletă.
 *
 *  Fără three.js: modulul îl folosesc și planșele 2D, care nu încarcă motorul 3D. */

/** Cât din saturație păstrează verdele lotului. */
export const SATURATIE_VERDE = 0.6;

const hex2 = (v: number) => Math.round(Math.min(1, Math.max(0, v)) * 255)
  .toString(16).padStart(2, "0");

/** Culoarea (`0xRRGGBB` sau `"#rrggbb"`) cu saturația înmulțită cu
 *  `SATURATIE_VERDE`, în HSL — luminozitatea și nuanța rămân. `"#rrggbb"`. */
export function verdeStins(culoare: number | string): string {
  const n = typeof culoare === "number" ? culoare : parseInt(culoare.replace("#", ""), 16);
  const r = ((n >> 16) & 255) / 255, g = ((n >> 8) & 255) / 255, b = (n & 255) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  const l = (max + min) / 2;
  if (max === min) return `#${hex2(r)}${hex2(g)}${hex2(b)}`;
  const d = max - min;
  const s = (l > 0.5 ? d / (2 - max - min) : d / (max + min)) * SATURATIE_VERDE;
  const h = max === r ? ((g - b) / d + (g < b ? 6 : 0)) / 6
    : max === g ? ((b - r) / d + 2) / 6 : ((r - g) / d + 4) / 6;
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const canal = (t: number) => {
    const u = t < 0 ? t + 1 : t > 1 ? t - 1 : t;
    return u < 1 / 6 ? p + (q - p) * 6 * u : u < 1 / 2 ? q : u < 2 / 3 ? p + (q - p) * (2 / 3 - u) * 6 : p;
  };
  return `#${hex2(canal(h + 1 / 3))}${hex2(canal(h))}${hex2(canal(h - 1 / 3))}`;
}

/** VERDELE LOTULUI, același în 2D și în 3D: iarba pe sol și cea peste subsol.
 *  Planșa 2D și macheta le citesc de aici, ca omul care trece de la una la
 *  cealaltă să vadă același spațiu verde, nu două.
 *
 *  Culori RAL, cerute pentru planul de situație, în echivalentul lor sRGB
 *  uzual (o culoare RAL e definită pe mostră, nu în RGB): zona închisă la
 *  culoare — spațiul verde pe sol — RAL 6004 (verde-albastru); zona deschisă —
 *  verdele peste subsol — RAL 6000 (verde patină). Date exact, nu prin
 *  `verdeStins`: sunt deja tonuri stinse. */
export const RAL_6000 = "#316650";
export const RAL_6004 = "#1f3a3d";
export const VERDE_SOL = RAL_6004;
export const VERDE_SUBSOL = RAL_6000;
